import React, { useEffect, useState } from "react";
import DefaultModalLayout from "../../../Modal/DefaultModalLayout";
import { DefaultModalCommonProps } from "../../Users/UserDetail/CommentModal/CommentModal";
import { ModalRow } from "../../Users/UserDetail/BlackListModal/BlackListModal";
import { ModalLabel } from "../../Users/UserDetail/CommentModal/TargetContainer";
import { ModalRowContentContainer } from "../../AlimTalk/AlimTalkModal";
import { Input } from "../../../Input/Input";
import ConfirmBtn from "../../../Button/ConfirmBtn";
import { useApi } from "../../../../hooks/useApi";
import Loader from "../../../DefaultStyles/Loader";
import Table from "../../../Table/Table";
import {
  FailTableBodyItem,
  TableBodyItemChild,
} from "../PayFail/CalculatePayFail";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import styled from "styled-components";
import { GetMoneyValue } from "../../../../ApiTS/ApiCommonTS";
import AlertModal from "../../../Modal/AlertModal";

interface Props extends DefaultModalCommonProps {}

interface SearchSaveUser {
  uid: number;
  nickname: string;
  name: string;
  id: number;
  time: string;
  err: string;
  list: [{ partyid: number; amount: number }];
}

export default function SaveModal({ closeEvent }: Props) {
  const navigate = useNavigate();
  const [uid, setUid] = useState("");
  const [search, setSearch] = useState(false);
  const [saveAskModal, setSaveAskModal] = useState(false);
  const [save, setSave] = useState(false);

  const {
    response: searchSaveRes,
    loading,
    error: searchSaveError,
  } = useApi({
    method: "get",
    url: search ? `pay/schedule/${uid}` : "",
  });

  const tableHead = ["UID_이름_닉네임", "탈퇴 사유", "PID", "금액"];

  const searchData = searchSaveRes?.data as SearchSaveUser;

  const { response, error } = useApi({
    method: "post",
    url: save ? `pay/lastSave` : "",
    data: {
      id: searchData?.id,
      reason: "save",
    },
  });

  useEffect(() => {
    if (searchData) {
      setSearch(false);
    }

    if (response?.status === 200) {
      closeEvent();
      toast.success("오늘도 한명의 고객을 구제했습니다");
    }
  }, [searchData, response]);

  useEffect(() => {
    if (error || searchSaveError) {
      toast.error(
        searchSaveError?.data ?? error?.data ?? "회원 조회에 실패하였습니다."
      );
    }
  }, [error, searchSaveError]);

  return (
    <>
      <DefaultModalLayout
        modalTitle="구제하기"
        closeEvent={closeEvent}
        confirmEvent={() => setSaveAskModal(true)}
        confirmBtnText="구제하기"
        confirmDisabled={!Boolean(searchData)}
      >
        <ModalRow>
          <ModalLabel>UID</ModalLabel>

          <ModalRowContentContainer>
            <Input
              value={uid}
              onChange={(e) => setUid(e.target.value)}
              placeholder="구제할 대상 UID를 입력해 주세요"
            />

            <ConfirmBtn
              btnText="검색"
              btnColor="mint"
              isDisabled={uid === ""}
              btnClickEvent={() => setSearch(true)}
            />
          </ModalRowContentContainer>
        </ModalRow>

        {searchData && (
          <>
            <ModalLabel>상세</ModalLabel>

            <ModalTableContainer>
              <Table tableHeadData={tableHead} tableMinWidth={600}>
                <FailTableBodyItem
                  style={{
                    textDecoration: "underline",
                    cursor: "pointer",
                    verticalAlign: "baseline",
                  }}
                  onClick={() => navigate(`/users/info/${searchData?.uid}`)}
                >
                  <TableBodyItemChild>
                    {searchData?.uid}_{searchData?.name}_{searchData?.nickname}
                  </TableBodyItemChild>
                </FailTableBodyItem>
                <FailTableBodyItem style={{ verticalAlign: "baseline" }}>
                  <TableBodyItemChild>sdfdsfdsfdsfsdfsfsfd</TableBodyItemChild>
                </FailTableBodyItem>
                <FailTableBodyItem>
                  {searchData?.list?.map((l, i) => (
                    <TableBodyItemChild
                      key={i}
                      style={{
                        textDecoration: "underline",
                        cursor: "pointer",
                      }}
                      onClick={() => navigate(`/party/info/${l.partyid}`)}
                    >
                      {l.partyid}
                    </TableBodyItemChild>
                  ))}
                </FailTableBodyItem>

                <FailTableBodyItem>
                  {searchData?.list?.map((l, i) => (
                    <TableBodyItemChild key={i}>
                      {GetMoneyValue(l.amount)}
                    </TableBodyItemChild>
                  ))}
                </FailTableBodyItem>
              </Table>
            </ModalTableContainer>
          </>
        )}
      </DefaultModalLayout>

      {loading && <Loader />}

      {saveAskModal && (
        <AlertModal
          title={`고객을 구제하시겠습니까?\n즉시 결제 됩니다.`}
          cancelEvent={() => setSaveAskModal(false)}
          confirmEvent={() => {
            setSaveAskModal(false);
            setSave(true);
          }}
          btnColor="red"
        />
      )}
    </>
  );
}

const ModalTableContainer = styled.div`
  width: 100%;
  overflow-x: scroll;
`;
